function initHeader() {
  const mobileMenu = document.getElementById("modal-main-menu");

  if (mobileMenu) {
    mobileMenu.querySelectorAll(".menu-item-link").forEach((link) => {
      link.addEventListener("click", () => {
        mobileMenu.close();
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", initHeader);
document.addEventListener("htmx:afterSwap", initHeader);
